var version = "{{VERSION}}";

/**
 * Copyright (C) IRT GmbH 2020
 *
 *   BR 2020 - Dialog plus via HbbTV 2 Multistream Synchronisation.
 */

var ATI = require('./js/tools/ati-tracking');

var AppMan = require('hbbtv-lib/main/appman');

var QS = require('hbbtv-lib/tools/query_string').get;
var debug = QS("debug");

var Logger = require('./js/tools/logging.js');
Logger.enable(debug);

function log(txt) {
	Logger.append("main.js: " + txt);
}

var _KeyEvent = require('./js/tools/keyevent_constants');

var materialResolver = require('./js/tools/materialResolver');

var MainPageMod = require('./js/widgets/main_page');
var FAQPageMod = require('./js/widgets/faq_page');
var TextPagMod = require('./js/widgets/text_page');
// var ErrPageMod = require('./js/widgets/err_page');

var DebugInfo  = require('./js/widgets/debug_info');

var filterCompanionStreams = require('./js/tools/filter-companion-streams')(
	debug, appConfig.TARGET, appConfig.SERVICE_TYPE_DIALOG_PLUS, appConfig.SERVICE_NAMES_DIALOG_PLUS,
	appConfig.SERVICE_TYPE_STANDARD, appConfig.SERVICE_NAMES_STANDARD);

// var errPage = null;
var mainPage = null;

var bcVideo = null;

var SyncPlayerFactory = null;

var Capabilities = null;
var mssPlayer = null;

var canMultistreamSync = false;
var needsMP4 = false;
var needsAVO = false;

var current_material = null;
// var current_companion_streams = null;

// var current_material_error = null;

var service_not_available = null;

var broadcast_audio_presented = true;

var broadcast_audio_track = { title : appConfig.broadcast_audio_title, id : 'broadcast', active : true };

// In HbbTV2 -> ES5 sollte keys bereits existieren
// if (!Object.keys) {
//     Object.keys = function (obj) {
//         var keys = [],
//             k;
//         for (k in obj) {
//             if (Object.prototype.hasOwnProperty.call(obj, k)) {
//                 keys.push(k);
//             }
//         }
//         return keys;
//     };
// }

/**
 * Initialize app.
 */
window.onload = function () {
	init_gui();
	init_sync();
};

// window.onunload = resetBroadcast;

/**
 * Initialize GUI.
 */
function init_gui() {

	AppMan.show();

	var app = document.getElementById("app");
	app.classList.add("multistream");

	var faqPage = FAQPageMod(app, faqConfig)
	var imprPage = TextPagMod(app, imprintConfig, { "{{APP}}" : "BR " + appConfig.title });

	mainPage = MainPageMod(app, appConfig, faqPage, imprPage);
	mainPage.setUsageInstructions(appConfig.usageInstructions.noContentAvailable);

	mainPage.on(mainPage.EVENT_TRACK_ACTIVATED, activateDialogPlus);
	mainPage.once(mainPage.EVENT_CLOSE, onAppCloseRequest);

	if (debug) {
		AppMan.addKey(AppMan.BLUE);
		document.addEventListener("keydown", function(e) {
			switch (e.keyCode) {
				case _KeyEvent.VK_BLUE: case e.VK_BLUE:
					Logger.toggle();
					console.log("toggle");
					break;
			}
		})
	}
	// try {
	// 	window.onunload = resetBroadcast;
	// 	document.onunload = resetBroadcast;
	// 	document.getElementsByTagName("body")[0].onunload = resetBroadcast;
	// } catch (e) {
	// }
}

/**
 * Initialize app2app communication and media synchronisation if supported by the TV.
 *
 * 1. Checks Capabilities to include Interdevice Sync with TEMI (IDS_TEMI)
 * 2. If device supports that or the URL includes debug flag continues otherwise stops
 * 3. Opens A2A websocket to wait for Companion Apps.
 * 4.
 */
function init_sync() {
	try {
		var msp = window["hbbtvMediasyncPlayer"];

		SyncPlayerFactory = msp.SyncPlayerFactory;
        Capabilities = msp.Capabilities;

		log(version, location.href.replace("&", "&amp;"));
		log("MSP library: " + msp.Version.name + " - " + msp.Version.date);
		if (debug) {
			var app = document.getElementById("app");
			DebugInfo(app, {appVersion: version, libVersion : msp.Version.name + " - " + msp.Version.date});
		}

        Capabilities.on("debug", function (msg) {
            Logger.append("Capabilities#debug: " + msg);
		});
		Capabilities.on("error", function (where, reason) {
			Logger.append("Capabilities#error: " + where + " - " + reason);
			switch (where) {
			case "retrievecapabilities":
				canMultistreamSync = false;
				updateStatus();
				break;
			}
		});
        Capabilities.on("capabilitiesavailable", function (caps) {
            Logger.append("Capabilities: " + caps);
//			Logger.append("Capabilities.hasCapability(\"MSS_TEMI_DASH\") : " + Capabilities.hasCapability('MSS_TEMI_DASH'));
//			Logger.append("Capabilities.hasCapability(\"MSS_TEMI_MP4\") : " + Capabilities.hasCapability('MSS_TEMI_MP4'));
//			Logger.append("Capabilities.hasCapability(\"MSS_HTML5\") : " + Capabilities.hasCapability('MSS_HTML5'));
//			Logger.append("Capabilities.hasCapability(\"MSS_AVO\") : " + Capabilities.hasCapability('MSS_AVO'));

			canMultistreamSync =
				(Capabilities.hasCapability('MSS_TEMI_DASH') || Capabilities.hasCapability('MSS_TEMI_MP4')) &&
				(Capabilities.hasCapability('MSS_HTML5') || Capabilities.hasCapability('MSS_AVO'));

			needsAVO = !Capabilities.hasCapability('MSS_HTML5');
			needsMP4 = !Capabilities.hasCapability('MSS_TEMI_DASH');
			var mss_offset = Capabilities.getNumericCapability('MSS_OFFSET');

			Logger.append("can MSS : " + canMultistreamSync + " - req. AVO: " + needsAVO + " - req. MP4: " + needsMP4 + " - offset " + mss_offset);

			if (debug && !canMultistreamSync) {
				// mainPage.setStatus("Funktion aktiviert für Debugging.");
				Logger.append("TESTING: Enable sync for all");
				canMultistreamSync = true;
				needsAVO = false;
				needsMP4 = false;
			}

			if (canMultistreamSync) {

				// get player for audio multistream sync
				mssPlayer = SyncPlayerFactory.getSyncPlayer();
				mssPlayer.setOffset(mss_offset);
				mssPlayer.on("error", function (msg) {
					Logger.append("MSSyncPlayer#error: " + msg);
				});
				mssPlayer.on("debug", function (msg) {
					Logger.append("MSSyncPlayer#debug: " + msg);
				});
				mssPlayer.on("mediaselected", onDialogPlusPlaying);
				mssPlayer.on("mediaunselected", onDialogPlusStopped);

				if (needsAVO) mssPlayer.setMode("AVO");
				if (needsMP4) mssPlayer.setMode("MP4");


				SyncPlayerFactory.on("error", function (msg) {
					Logger.append("SyncPlayerFactory#error: " + msg);
				});

				SyncPlayerFactory.on("debug", function (msg) {
					Logger.append("SyncPlayerFactory#debug: " + msg);
				});

				SyncPlayerFactory.on("mastermediaready", function (mId) {
					try {
						mainPage.showOnOffButton(true);
						Logger.append("SyncPlayerFactory#mastermediaready fired: " + mId);
					} catch (e) {
						Logger.append("SyncPlayerFactory#mastermediaready: " + e);
					}
				});
				SyncPlayerFactory.on("mastermediareset", function (mId) {
					Logger.append("SyncPlayerFactory#mastermediareset fired: " + mId);
				});
				SyncPlayerFactory.on("mastermedia_syncdisabled", function (mId) {
					Logger.append("SyncPlayerFactory#mastermedia_syncdisabled fired: " + mId);
				});

				prepareBroadcast();
			} else {
				if (console) console.log(" updateStatus");
				updateStatus();
			}
        });
		Capabilities.retrieveCapabilities();

	} catch (e) {
		log("initSync: " + e);
		// console.log(e);
	}
};

/**
 * Initialize video/broadcast object.
 *
 * 	Bind object to current channel.
 *  Each time the playState reaches 2 continue with MRS (requestMaterial)
 */
function prepareBroadcast () {
	try {
		bcVideo = document.getElementById("bcVideo");

		// add for logging state and component changes
		bcVideo.addEventListener("PlayStateChange", function (evt) {
			log("VBO#PlayStateChange - evt state = " + evt.state + " - evt error = " + evt.error + " - obj state " + bcVideo.playState);
		}, false);
		bcVideo.addEventListener("SelectedComponentChange", function (evt) {
			try {
				switch (evt.componentType) {
					case (bcVideo.COMPONENT_TYPE_AUDIO | 1):
						var c = bcVideo.getCurrentActiveComponents(evt.componentType).item(0);
						log("SelectedComponentChange: active audio PID: " + c.pid + " - lang: " + c.language);
						break;
					default:
						log("SelectedComponentChange: component type: " + evt.componentType);
						break;
				}
			} catch (e) {
				log("Exc: SelectedComponentChange: " + e);
			}
		}, false);

		bcVideo.addEventListener("ProgrammesChanged", function (evt) { ATI.updateProgramme(bcVideo, evt) });

		// wait for bc obj to enter presenting state
		bcVideo.addEventListener("PlayStateChange", on_bc_presenting, false);
		bcVideo.bindToCurrentChannel();
		on_bc_presenting();

	} catch (error) {
		log("prepareBroadcast: " + error);
	}
}

/**
 * Event handler listening on state changes on the V/B object to execute
 * any actions when the object reaches the PRESENTING state.
 */
function on_bc_presenting () {
	try {
		log ("on_bc_presenting " + bcVideo.playState);
		if (bcVideo.playState == 2) {
			bcVideo.removeEventListener("PlayStateChange", on_bc_presenting, false);

			var resolver = materialResolver(bcVideo.currentChannel, appConfig.mspdata_polling_ms);
			resolver.on('material_update', handle_material);
			resolver.on('error', handle_material_error);
			resolver.on('debug', Logger.append);

			ATI.on("debug", function (txt) {
				Logger.append("ATITracking: " + txt);
			});
			ATI.updateProgramme(bcVideo);

			log("network id: " + bcVideo.currentChannel.nid);
		}
	} catch (e) {
		log("on_bc_presenting: " + e);
	}
};

/**
 * Handles updates of material information.
 *
 * Look for dialogplus
 */
function handle_material (_current_material) {
	try {
		log("Material update received: " + _current_material.companionstreams.length + " companion streams.");

		/**
		 * @type {Array}
		 */
		var dp_streams = filterCompanionStreams(_current_material.companionstreams);

		if (dp_streams.length > 0) {
			_current_material.master.playerRef = bcVideo;
			if (current_material === null) {
				log("First material info, set master media");
				SyncPlayerFactory.setMasterMedia(_current_material.master);
			}
		}

		dp_streams.unshift(broadcast_audio_track);
		mainPage.setTracks(dp_streams);

		// current_companion_streams = dp_streams;

		ATI.updateSyncMaterial(_current_material);
		if (current_material == null) {
			ATI.send(ATI.EVENT1);
		}
		current_material = _current_material;

		// programme changed reset broadcast if broadband still playing
		if (!broadcast_audio_presented)
			activateDialogPlus(broadcast_audio_track);

		updateStatus();

	} catch (e) {
		log("exc: handle_material: " + e);
	}
}

/**
 * Handles error events from material resolver.
 *
 * @param {string} reason expect either TIMEOUT or NOTFOUND
 */
function handle_material_error (reason) {
	try {
		// current_material_error = reason;
		// log("Can't get material information " + reason);
		if (reason === "NOTFOUND") {
			service_not_available = true;
		}

		updateStatus();
	} catch (e) {
		log("exc: handle_material_error" + e);
	}
}

/**
 *
 * @param {Track} track
 */
function activateDialogPlus(track) {
	try {
		log("Activate DP: " + track.id);
		// remove listener to avoid that it gets fired because of our unselectMedia calls.
		mssPlayer.removeListener("mediaunselected", resetBroadcast);
		if (track.id !== broadcast_audio_track.id) {

			if (broadcast_audio_presented) {
				bcVideo.unselectComponent(bcVideo.COMPONENT_TYPE_AUDIO || 1);
			} else {
				mssPlayer.unselectMedia();
			}
			mssPlayer.selectMedia(track);
			mssPlayer.once("mediaselected", function () {
				log("Activate DP: set onetime listener that is fired when broadband finishes playback.");
				mssPlayer.once("mediaunselected", resetBroadcast);
			});
			broadcast_audio_presented = false;

			ATI.send(ATI.EVENT4, { slaveId : track.id } );

		} else {
			mssPlayer.unselectMedia();
			resetBroadcast();
		}
		updateStatus();

	} catch (e) {
		log("Exc: activateDialogPlus(): " + e);
	}
}

/**
 * Resets broadcast audio, i.e. selects an audio component (lets the terminal choose one),
 * and marks the broadcast audio in the menu on the main page widget.
 */
function resetBroadcast() {
	try {
		if (!broadcast_audio_presented) {
			bcVideo.selectComponent(bcVideo.COMPONENT_TYPE_AUDIO || 1);
			broadcast_audio_presented = true;

			mainPage.markTrackActive(broadcast_audio_track, true);
		}
	} catch (e) {
		log("Exc: reset_broadcast(): " + e);
	}
}

/**
 * Called when the SyncPlayer notifies slave media started playing
 *
 * @param {string} id
 */
function onDialogPlusPlaying(id) {
	log("DP playing: " + id);
}

/**
 * Called when the SyncPlayer notifies slave media stopped playing/finished.
 *
 * Calls resetBroadcast().
 *
 * @param {string} id
 */
function onDialogPlusStopped(id) {
	try {
		log("DP stopped: " + id);
//		resetBroadcast();
	} catch (e) {
		log("Exc. onDialogPlusStopped(): " + e);
	}
}

/**
 *
 *
 * @param {string} [url] optional url
 */
function onAppCloseRequest (url) {
	if (broadcast_audio_presented) {
		closeApp(url);
	} else {
		log("received closed request, stop broadband and restore broadcast.");
		mssPlayer.once("mediaunselected", closeApp.bind(null, url));
		activateDialogPlus(broadcast_audio_track);
	}
}

/**
 * Close this application. Parameter is for testing, e.g. return to test portal. If parameter is not present returns to app configured
 * in config-*.js
 *
 * If a url is given, does not start a new application, but sets window.location to this URL.
 *
 * @param {string} url
 */
function closeApp (url) {
	if (url) {
		window.location = url;
	} else {
		AppMan.createApp(appConfig.startleiste);
	}
}

/**
 * Show status messages and usage instructions.
 * - Messages can be configured in config-ad.js
 * - the instruction in case no content is available is only shown on delivery networks and devices that both are supported
 * - if the no content is available instruction is shown the status field is removed from screen.
 */
function updateStatus() {
	var usage = appConfig.usageInstructions.contentAvailable;

	if (!canMultistreamSync) {
		usage = appConfig.usageInstructions.dvcNotSupported;

	} else if (service_not_available) {
		usage = appConfig.usageInstructions.svcNotAvailable;

	} else if (current_material.companionstreams.length === 0) {
		usage = appConfig.usageInstructions.noContentAvailable;

	} else if (!broadcast_audio_presented) {
		usage = appConfig.usageInstructions.contentSelected;
	}

	mainPage.setUsageInstructions(usage);
}
